<template>
    <div class='container'>
        <button class='close' @click="$emit('close')">
            <span class='blind'>팝업 닫기</span>
        </button>

        <div class='title'>[{{ ticketType | formatTicketType }}] 출석 현황 상세</div>

        <div class='scroll-area com-scroll-y'>
            <table class='com-table'>
                <colgroup>
                    <col style='width: 30%;'>
                    <col style='width: 40%;'>
                    <col style='width: 30%;'>
                </colgroup>

                <thead>
                <tr>
                    <th>수업일자</th>
                    <th>이용권명</th>
                    <th>강사명</th>
                </tr>
                </thead>

                <tbody>
                <tr v-for='usage in usages'>
                    <td>{{ usage.less_dt | formatDate("YYYY-MM-DD (ddd) HH:mm") }}</td>
                    <td>{{ usage.prod_name }}</td>
                    <td>{{ usage.staff_name }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';

export default {
    name: 'TicketUsage',

    props: {
        month: String,
        centerId: Number | String,
        customerId: Number,
        ticketType: String,
    },

    data() {
        return {
            usages: [],
        }
    },

    mounted() {
        this.getTicketUsage();
    },

    methods: {
        async getTicketUsage() {
            const { data } = await api.get(`/admin/api/center/${this.centerId}/lesson/schedule/customer/${this.customerId}/attendance`, {
                params: {
                    month: this.month,
                    ticketType: this.ticketType,
                },
            });

            this.usages = data;
        }
    }
}
</script>

<style scoped lang='scss'>
.vm--modal {
    .container {
        padding: 24px;
    }

    .title {
        padding-top: 48px;
        padding-bottom: 24px;
        font-size: 20px;
        font-weight: bold;
        color: #535353;
    }

    .close {
        float: right;
        width: 20px;
        height: 20px;
        background: url(/img/icons/layerpop_square_close_btn.jpg) no-repeat 0 0;
        border: none;
    }

    .center {
        display: block;
        width: 100%;
        height: 56px;
        margin-top: 16px;
        border-radius: 0;
        border: 1px solid #e1e1e1;
        background: #f1f5f7;
        font-size: 16px;
        text-align: center;
        color: #7e7777;
    }

    .scroll-area {
        overflow: auto;
        max-height: 490px;
    }

    table th {
        position: sticky;
        top: 0;
    }
}
</style>
